import { ValidatorMapping } from './validator-mapping';
/**
 * Takes a validator mapping and returns a function that will map a propertyMapping to a validatorMapping
 *
 * @param mapping Validator mapping
 */
export function validatorMapping(mapping) {
    var validatorMapping = new ValidatorMapping(mapping);
    return function (propertyMapping) { return validatorMapping.mapPropertyMapping(propertyMapping); };
}
//# sourceMappingURL=validator-mapping-factory.js.map